import { X } from "lucide-react";

export function Modal({ open, onClose, title, children, testid = "modal" }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-start justify-center overflow-y-auto bg-black/70 p-4 backdrop-blur-sm" data-testid={testid}>
      <div className="my-8 w-full max-w-lg rounded-2xl border border-gold/20 bg-obsidian-card p-6 shadow-2xl">
        <div className="mb-5 flex items-center justify-between">
          <h3 className="font-display text-xl font-bold text-white">{title}</h3>
          <button onClick={onClose} className="rounded-lg p-1.5 text-slate-400 hover:bg-white/5 hover:text-white" data-testid={`${testid}-close`}>
            <X className="h-5 w-5" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <div>
      <label className="mb-1.5 block text-sm font-medium text-slate-300">{label}</label>
      {children}
    </div>
  );
}

const base = "h-11 w-full rounded-lg border border-gold/20 bg-obsidian px-3 text-slate-100 outline-none focus:border-gold/60";

export function TextInput({ testid, ...props }) {
  return <input {...props} data-testid={testid} className={base} />;
}

export function TextArea({ testid, ...props }) {
  return <textarea {...props} data-testid={testid} rows={4} className={`${base} h-auto py-2`} />;
}

export function Toggle({ checked, onChange, label, testid }) {
  return (
    <button type="button" onClick={() => onChange(!checked)} data-testid={testid}
      className="flex items-center gap-2 text-sm font-medium text-slate-300">
      <span className={`relative h-6 w-11 rounded-full transition-colors ${checked ? "bg-whatsapp" : "bg-slate-600"}`}>
        <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-white transition-transform ${checked ? "translate-x-5" : "translate-x-0.5"}`} />
      </span>
      {label}
    </button>
  );
}

export function PrimaryButton({ children, testid, ...props }) {
  return (
    <button {...props} data-testid={testid}
      className="inline-flex h-11 items-center justify-center gap-2 rounded-lg gold-gradient px-6 font-bold text-obsidian transition-transform hover:scale-[1.02] disabled:opacity-50">
      {children}
    </button>
  );
}
